module.exports = __webpack_public_path__ + "static/key-vicioussisters-f55063097564fe91ef2e4dd144c68d6f.webp";